import { Order, OrderRejectStatus, OrderStatus, OrderType, OperationButtonsConfig, InvoicingState } from 'models/order';
import { currentOrgVar } from 'apollo/reactive-variables/organization';
import { permissions } from 'utils/permission';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { User } from 'models/user';
import { isCustomer, isSupplier } from 'utils/client-settings';

export const getOrderDetailsStatusButtons = (status: OrderStatus) => {
    switch (status.toUpperCase()) {
        case OrderStatus.SENT_BY_CUSTOMER:
            return getStatusConfig('acceptByLab', status.toUpperCase());
        case OrderStatus.ACCEPTED_BY_LAB:
            return getStatusConfig('sentByLab', status.toUpperCase());
        case OrderStatus.SENT_BY_LAB:
        case OrderStatus.ORDER_APPROVED:
            return getStatusConfig('', status.toUpperCase());
        default:
            return undefined;
    }
};
const getStatusConfig = (state: string, orderStatus: string) => {
    return {
        approveOrder:
            OrderStatus.ORDER_APPROVED !== orderStatus &&
            orderStatus !== OrderStatus.ACCEPTED_BY_LAB &&
            orderStatus !== OrderStatus.SENT_BY_CUSTOMER,
        acceptByLab: state === 'acceptByLab',
        sentByLab: state === 'sentByLab',
        labWorkStarted: state === 'labWorkStarted',
    };
};

const getOperationButtonConfig = (
    unArchiveOrder: boolean,
    archiveOrder: boolean,
    rateOrder: boolean,
    cancelOrder: boolean,
    declineByLab: boolean,
    resendOrder: boolean,
) => {
    return {
        unArchiveOrder: unArchiveOrder,
        archiveOrder: archiveOrder,
        rateOrder: rateOrder,
        cancelOrder: cancelOrder,
        declineByLab: declineByLab,
        resendOrder: resendOrder,
    };
};

export const getOrderDetailsOperationButtons = (order: Order) => {
    const currentUser = currentUserVar();
    const currentOrganization = currentOrgVar();
    let showOperationButtons = {
        unArchiveOrder: false,
        archiveOrder: false,
        rateOrder: false,
        cancelOrder: false,
        declineByLab: false,
        resendOrder: false,
    };
    showOperationButtons = getButtonsState(order, showOperationButtons, currentUser);

    if (order.archived?.byCustomer && isCustomer(currentOrganization._id, order.customer._id)) {
        showOperationButtons.unArchiveOrder = true;
        showOperationButtons.archiveOrder = false;
    }
    if (order.archived?.byLab && isSupplier(currentOrganization._id, order.supplier._id)) {
        showOperationButtons.unArchiveOrder = true;
        showOperationButtons.archiveOrder = false;
    }
    if (order.isProductionFinished || order.invoicingState !== InvoicingState.NOT_READY) {
        showOperationButtons.resendOrder = false;
    }
    if (isCustomer(currentOrganization._id, order.customer._id) && order.isCreatedByLab) {
        showOperationButtons.resendOrder = true;
    }
    if (
        !order.isCreatedByLab &&
        order.type === OrderType.ACTION_BASED &&
        isCustomer(currentOrganization._id, order.customer._id) &&
        (order.isProductionFinished || order.invoicingState !== InvoicingState.NOT_READY)
    ) {
        showOperationButtons.resendOrder = false;
    }
    if (
        permissions.isLabTechnician(currentUser?.type) &&
        (order.isProductionFinished || order.invoicingState !== InvoicingState.NOT_READY)
    ) {
        showOperationButtons.resendOrder = false;
    }
    return showOperationButtons;
};

const getButtonsState = (order: Order, showOperationButtons: OperationButtonsConfig, currentUser: User) => {
    let declineOrder = false;
    let resendOrder = false;
    const currentOrganization = currentOrgVar();
    const isCustomerUser = isCustomer(currentOrganization._id, order.customer._id);

    if (isCustomerUser) {
        resendOrder = true;
    }
    if (permissions.isLabTechnician(currentUser?.type)) {
        declineOrder = true;
    }

    switch (order.status.toUpperCase()) {
        case OrderStatus.SENT_BY_CUSTOMER:
            showOperationButtons = getOperationButtonConfig(false, false, false, true, declineOrder, resendOrder);
            break;
        case OrderStatus.ACCEPTED_BY_LAB:
            showOperationButtons = getOperationButtonConfig(
                false,
                isCustomerUser,
                false,
                true,
                declineOrder,
                resendOrder,
            );
            break;
        case OrderStatus.SENT_BY_LAB:
            showOperationButtons = getOperationButtonConfig(false, true, true, false, false, true);
            break;
        case OrderStatus.ORDER_APPROVED:
            showOperationButtons = getOperationButtonConfig(false, true, false, false, false, false);
            break;
        default:
            break;
    }
    switch (order.rejectStatus?.toUpperCase()) {
        case OrderRejectStatus.CANCELLED:
            showOperationButtons = getOperationButtonConfig(false, true, false, false, false, resendOrder);
            break;
        case OrderRejectStatus.DECLINED:
            showOperationButtons = getOperationButtonConfig(false, true, false, false, false, resendOrder);
            break;
        default:
            break;
    }
    return showOperationButtons;
};
